type Props = {
    isLoading: boolean,
    children: any,
    customClass?: string
}

const Loader = ({isLoading, children, customClass}: Props) => {
    return (
        <div className={`loader ${isLoading ? "text-center" : ""} ${customClass ? customClass : ""}`}>
            {
                isLoading ? (
                    <span className="loading-sign">
                        <span className="loading-sign__spinner" />
                    </span>
                ) : (
                    <div className={`loader-content ${!isLoading ? "active" : ""}`}>
                        {children}
                    </div>
                )
            }
        </div>
    );
};

export default Loader;
